import React from 'react';
import Text from 'components/Text/Text';
import authBackground from 'images/authBackground.png';

interface IProps {
	children: React.ReactNode;
	dataTest: string;
}

export const AuthLayout: React.FC<IProps> = ({ children, dataTest }) => {
	return (
		<div className="relative flex h-full" data-test={dataTest}>
			<div
				className="hidden h-full w-1/2 shrink-0 bg-cover bg-center md:block"
				style={{ backgroundImage: `url(${authBackground})` }}
			/>
			<div className="flex h-full flex-1 flex-col items-center px-6">
				<div className="flex flex-1 items-center justify-center">{children}</div>
				<Text
					className="mb-4"
					translationKey={`© ${new Date().getFullYear()} KateMedia`}
					theme="neutralMedium"
					align="center"
				/>
			</div>
		</div>
	);
};
